import React from 'react';

import {
  RichTextAlignEnum,
  RichTextBlockEnum,
  RichTextNodeType,
} from '../properties/baseTypes/RichText';

function RichTextNode({
  node,
  blockStyle,
}: {
  node?: RichTextNodeType;
  blockStyle?: React.CSSProperties;
}) {
  function renderChildren() {
    return node?.children?.map((node, i) => (
      <RichTextNode key={`${node}${i}`} node={node} blockStyle={blockStyle} />
    ));
  }

  if (node?.text) {
    return (
      <span
        style={{
          fontWeight: node.bold ? 'bold' : 'normal',
          fontStyle: node.italic ? 'italic' : 'normal',
          textDecoration: node.underlined ? 'underline' : 'none',
        }}
      >
        {node.text}
      </span>
    );
  }

  const alignStyle = { textAlign: node?.align || RichTextAlignEnum.left };

  switch (node?.type) {
    case RichTextBlockEnum.H1:
      return (
        <h1 style={{ ...alignStyle, ...blockStyle }}>{renderChildren()}</h1>
      );
    case RichTextBlockEnum.H2:
      return (
        <h2 style={{ ...alignStyle, ...blockStyle }}>{renderChildren()}</h2>
      );
    case RichTextBlockEnum.H3:
      return (
        <h3 style={{ ...alignStyle, ...blockStyle }}>{renderChildren()}</h3>
      );
    case RichTextBlockEnum.H4:
      return (
        <h4 style={{ ...alignStyle, ...blockStyle }}>{renderChildren()}</h4>
      );
    case RichTextBlockEnum.H5:
      return (
        <h5 style={{ ...alignStyle, ...blockStyle }}>{renderChildren()}</h5>
      );
    case RichTextBlockEnum.H6:
      return (
        <h6 style={{ ...alignStyle, ...blockStyle }}>{renderChildren()}</h6>
      );
    case RichTextBlockEnum.BlockQuote:
      return <blockquote style={blockStyle}>{renderChildren()}</blockquote>;
    case RichTextBlockEnum.BulletedList:
      return <ul style={blockStyle}>{renderChildren()}</ul>;
    case RichTextBlockEnum.ListItem:
      return <li style={blockStyle}>{renderChildren()}</li>;
    case RichTextBlockEnum.NumberedList:
      return <ol style={blockStyle}>{renderChildren()}</ol>;
    case RichTextBlockEnum.Code:
      return <code style={blockStyle}>{renderChildren()}</code>;
    case RichTextBlockEnum.Link:
      return (
        <a href={node.url} target="_blank" rel="noopener noreferrer">
          {renderChildren()}
        </a>
      );
    case RichTextBlockEnum.Paragraph:
    default:
      return <p style={{ ...alignStyle, ...blockStyle }}>{renderChildren()}</p>;
  }
}

export default function RichTextHtmlRenderer({
  value,
  blockStyle,
}: {
  value?: RichTextNodeType[];
  blockStyle?: React.CSSProperties;
}) {
  // note: returning these fragments keeps tsc happy, don't remove them
  if (!value) {
    return <></>;
  }

  return (
    <>
      {value.map((node, i) => (
        <RichTextNode key={`${node}${i}`} node={node} blockStyle={blockStyle} />
      ))}
    </>
  );
}
